import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  todoCount: 0,
  wordingsCount: 0,
};

export const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    countToDo: (state, action) => {
      state.todoCount = action.payload;
    },
    countWordings: (state, action) => {
      state.wordingsCount = action.payload;
    },
  },
});

export const { countToDo, countWordings } =
  todoSlice.actions;

export default todoSlice.reducer;
